import React, { useState, useEffect } from 'react';
import Icon from 'screens/shared/icon';
import Card from 'screens/shared/card';
import { _t } from 'utils';
import Utils from 'screens/shared/utilities';
import Text from './input-field';

export default ({
  onChange = null,
  devices = [],
  error = '',
}) => {
  const [items, setItems] = useState([]);
  const [filters, setFilers] = useState({
    search: '',
  });

  useEffect(() => {
    setItems([...devices.map((e) => ({ ...e, isSelected: false }))]);
  }, [devices]);

  const setFilter = (valueParam) => setFilers((e) => ({ ...e, ...valueParam }));

  const onItemSelect = (item) => {
    item.isSelected = true;
    const updatedItems = items.map((e) => ({ ...e, isSelected: false }));
    const index = updatedItems.findIndex(({ id }) => id === item.id);
    updatedItems[index] = item;
    setItems([...updatedItems]);
    if (onChange) {
      onChange(item);
    }
  };

  let filteredItems = items;

  if (filters.search) {
    filteredItems = filteredItems
      .filter(({ properties: { name = '' } }) => name.toLowerCase().indexOf(filters.search.toLowerCase()) !== -1);
  }

  return (
    <>
      <div className="image-selector" style={error ? { border: '1px solid var(--color-danger)' } : {}}>
        <div className="image-selector-top">
          <Text
            label={_t('Search')}
            value={filters.search}
            onChange={(valueParam) => setFilter({ search: valueParam })}
          />
        </div>

        <div className="cards" style={{ margin: 0 }}>
          {filteredItems.map((item) => {
            const {
              id, type, properties: { name, size }, isSelected = false, // image, volume
            } = item;
            return (
              <Card key={id} className={!!isSelected && 'selected'} onClick={() => onItemSelect(item)} isArrow={false}>
                <div className="cards-left">
                  <div className="cards-storage-left-logo">
                    <Icon name={type === 'image' ? 'compact-disc' : 'hdd'} />
                  </div>
                </div>

                <div className="cards-right" style={{ flexGrow: 1 }}>
                  <span className="cards-right-title">{name}</span>

                  <div className="cards-right-props">
                    <div>
                      <span>
                        {size}
                        {' '}
                      GB
                      </span>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
          {!filteredItems.length && <Utils.NoData />}
        </div>
      </div>
      {error && <span style={{ color: 'var(--color-danger)' }}>{error}</span>}
    </>
  );
};
